
import { defineComponent, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../store";
export default defineComponent({
  name: "LogIn",
  setup() {
    const userInfo = reactive({
      email: "",
      password: "",
    });

    const store = useStore();
    const router = useRouter();

    const logIn = async () => {
      if (await store.dispatch("login", userInfo)) router.push("/reservations");
    };

    return {
      ...toRefs(userInfo),
      logIn,
    };
  },
});
